import styled from 'styled-components'

export default styled.a`
  @keyframes shadow-vibes {
    from {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.5);
    }

    to {
      box-shadow: 0 0 0 2.5px rgba(220, 53, 69, 0.5);
    }
  }

  animation: shadow-vibes 0.5s ease-in-out infinite alternate;
`
